/* components */
import Confirm from './modal-confirm';
import Delete from './modal-delete';
import Default from './modal-default';
/* styles */
import './modal.scss';

const Modal = {
  Confirm,
  Delete,
  Default,
};

export default Modal;
